import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const isEditingStorage = (storage: EStorageType) =>
    storage === EStorageType.myofficeAttaches ||
    storage === EStorageType.myoffice ||
    storage === EStorageType.r7 ||
    storage === EStorageType.office;

export const isEditingAttach = (storage: EStorageType) => storage === EStorageType.myofficeAttaches;
